module.exports = (__webpack_require__(0))(173);


//////////////////
// WEBPACK FOOTER
// delegated ./src/collections/AssetstoreCollection.js from dll-reference girder_lib
// module id = 21
// module chunks = 0